import React from 'react';
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleCreatedImg from "../../../assets/images/moduleCreatedModal.svg";
const ModuleCreatedModal = ({ handleModal }) => {
    return (
        <>
            <Modal.Header >
            </Modal.Header>
            <Modal.Body>
                <div className='text-center'>
                    <img src={ModuleCreatedImg} alt="ScratchImg" />
                    <div className='px-5 pt-4 pb-3'>
                        <h3 className='mt-3 mb-2'>Amazing! Your first module is created</h3>
                        <p className='text-gray-300 mb-0 mb-0'>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                        </p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end btnFooter gap-2">
                <Link className='btn-white btn-sm' onClick={() => handleModal(false)}>
                    Replay  guides
                </Link>
                <Link className="btn-primary btn-sm text-base-100" onClick={() => handleModal(false)}>
                    Got it
                </Link>
            </Modal.Footer>
        </>
    );
}

export default ModuleCreatedModal;
